import axios from 'axios';

window.TABS = window.TABS || {}
// Legacy part of API. Still used by Skantraf (officeId:109) on premium web
// TODO: Should probably log usage here and if there are no usage left, we should remove this part
window.TABS.legacy = {
    showBack: function() {
        document.getElementById('resetPassForm').classList.add('hidden');
        document.getElementById('loginForm').classList.remove('hidden');
    },
    resetPassForm: function() {
        document.getElementById('resetPassForm').classList.remove('hidden');
        document.getElementById('loginForm').classList.add('hidden');
    },
    postResetPassForm: function(e) {
        const $form = e;
        const $btn = document.querySelector('#resetPassForm .btn');
        $btn.setAttribute('data-loading', 'true');

        const data = new FormData($form);
        data.append('officeId', officeId);

        axios.post(TABS.api.getEndPoint('reset_password'), new URLSearchParams(data))
        .then(response => response.data)
        .then(result => {
            $btn.removeAttribute('data-loading');
            if (result.status === 'ok') {
                $form.querySelector('input[name="username"]').value = '';
                document.querySelector('#resetPassForm .result').innerHTML = result.html;
                document.querySelector('#resetPassForm .result').classList.add('alert', 'alert-success');

                setTimeout(function () {
                    document.querySelector('._showBack').click();
                }, 3000);
            } else {
                alert(result.message);
            }
        })
        .catch(() => {
            $btn.removeAttribute('data-loading');
            alert('Noe gikk galt. Vennligst last inn siden på nytt og prøv igjen.');
        });
        return false;
    },
    postRegisterForm: function(e) {
        const $form = e;
        const $btn = document.querySelector('#registerForm .btn');
        $btn.setAttribute('data-loading', 'true');

        const data = new FormData($form);
        data.append('officeId', officeId);

        axios.post(TABS.api.getEndPoint('register'), new URLSearchParams(data))
        .then(response => response.data)
        .then(result => {
            $btn.removeAttribute('data-loading');
            TABS.analytics.triggerAnalyticsEvent('courses', 'booking', 'register', result.status === 'ok' ? 1 : 0);
            if (result.status == 'ok') {
                $form.innerHTML = result.html;
                document.getElementById('loginTab').classList.add('hidden');
            } else {
                alert(result.message);
            }
            submitInProgress = false;
        })
        .catch(() => {
            $btn.removeAttribute('data-loading');
            TABS.analytics.triggerAnalyticsEvent('courses', 'booking', 'register', 0);
            alert('Noe gikk galt. Vennligst last inn siden på nytt og prøv igjen.');
            submitInProgress = false;
        });

        return false;
    },
    postLoginForm: function(e) {
        const $form = e;
        const $btn = document.querySelector('#loginForm .btn');
        $btn.setAttribute('data-loading', 'true');

        const data = new FormData($form);
        data.append('officeId', officeId);

        axios.post(TABS.api.getEndPoint('do_booking'), new URLSearchParams(data))
        .then(response => response.data)
        .then(result => {
            $btn.removeAttribute('data-loading');
            TABS.analytics.triggerAnalyticsEvent('courses', 'booking', 'login', result.status === 'ok' ? 1 : 0);

            if (result.status === 'ok') {
                document.querySelector('._popupContent').innerHTML = result.html;
            } else {
                alert(result.message);
                if (result.refresh_list) {
                    if (typeof getSlots === "function") {
                        getSlots(document.querySelector('.fc-day-top.Active').dataset.date);
                    }
                }
            }
        })
        .catch(() => {
            $btn.removeAttribute('data-loading');
            TABS.analytics.triggerAnalyticsEvent('courses', 'booking', 'login', 0);
            alert('Noe gikk galt. Vennligst last inn siden på nytt og prøv igjen.');
        });
        return false;
    },
}